import KlientStore from 'src/stores/KlientStore';
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { FormControlLabel, RadioGroup, Radio, Drawer, Grid, AppBar, Toolbar, IconButton, Typography, Paper, List, ListItem, ListItemText, ListItemIcon, Fab, Table, TableHead, TableRow, TableCell, TableBody, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField, Tooltip } from '@material-ui/core';
import { observable, action, computed } from 'mobx';
import NavigationDrawerItems from './NavigationDrawerItems';
import MenuIcon from '@material-ui/icons/Menu';
import { withRouter, RouteComponentProps } from 'react-router';
import PersonIcon from '@material-ui/icons/Person'
import AddIcon from '@material-ui/icons/Add';
import Klient from 'src/models/Klient';
import TurnusStore from 'src/stores/TurnusStore';
import moment from 'moment';
import ObjednavkaStore from 'src/stores/ObjednavkaStore';
import FakturaceStore from 'src/stores/FakturaceStore';

export interface IClientsProps extends RouteComponentProps<any> {
    klientStore?: KlientStore;
    turnusStore?: TurnusStore;
    objednavkaStore?: ObjednavkaStore;
    fakturaceStore?: FakturaceStore;
}

@inject('klientStore')
@inject('turnusStore')
@inject('objednavkaStore')
@inject('fakturaceStore')
@observer
class Clients extends React.Component<IClientsProps>{

    constructor(props: Readonly<IClientsProps>) {
        super(props);
        console.log("LOAD: Clients");
    }

    @observable private isNewKlientDialogOpened: boolean = false;
    @observable private newKlientJmeno: string = "";
    @observable private newKlientPrijmeni: string = "";
    @observable private newKlientTelefon: string = "";
    @observable private newKlientEmail: string = "";
    @observable private newKlientUlice: string = "";
    @observable private newKlientMesto: string = "";
    @observable private newKlientPoznamka: string = "";
    @observable private newKlientPSC: string = "";

    @observable private filter: string = 'active';
    @computed private get klientComputed(): Klient[] {
        if(this.filter === 'active') {
            return this.filterActive;
        }
        if(this.filter === 'sent') {
            return this.filterUnpaid;
        }
        if(this.filter === 'new') {
            return this.filterNew;
        }
        return this.props.klientStore.klients;
    }

    @computed
    private get filterActive(): Klient[] {
        return this.props.klientStore.klients.filter(kl => {
            let retVal: boolean = false;
            this.props.turnusStore.getTurnusyByKlientID(kl.id).forEach(turnus => {
                if(moment().isBetween(turnus.od, turnus.do, 'day', '[]')) {
                    retVal = true;
                }
            });
            return retVal;
        });
    }

    @computed
    private get filterUnpaid() : Klient[] {
        return this.props.klientStore.klients.filter(kl => {
            let retVal: boolean = false;
            this.props.turnusStore.getTurnusyByKlientID(kl.id).forEach(turnus => {
                if(turnus.idObjednavka !== 0) {
                    const obj = this.props.objednavkaStore.getObjednavkaByID(turnus.idObjednavka);
                    if(obj.stav === 'odeslany') {
                        retVal = true;
                    }
                }
            });
            return retVal;
        });
    }

    @computed
    private get filterNew() : Klient[] {
        return this.props.klientStore.klients.filter(kl => {
            let retVal: boolean = false;
            this.props.turnusStore.getTurnusyByKlientID(kl.id).forEach(turnus => {
                if(turnus.idObjednavka !== 0) {
                    const obj = this.props.objednavkaStore.getObjednavkaByID(turnus.idObjednavka);
                    if(obj.stav === 'novy') {
                        retVal = true;
                    }
                }
            });
            return retVal;
        });
    }

    @action
    private handleChange = name => event => {
        this[name] = event.target.value;
    };

    @action
    private onCloseDialog = event => {
        this.isNewKlientDialogOpened = !this.isNewKlientDialogOpened;
    }

    @action
    private onSaveNewKlient = event => {
        this.isNewKlientDialogOpened = !this.isNewKlientDialogOpened;
        const klient = this.props.klientStore.createNewClient(this.newKlientJmeno, this.newKlientPrijmeni, this.newKlientTelefon, this.newKlientEmail, this.newKlientUlice, this.newKlientMesto, this.newKlientPoznamka, this.newKlientPSC);
        this.newKlientJmeno = "";
        this.newKlientTelefon = "";
        this.newKlientEmail = "";
        this.newKlientPrijmeni = "";
        this.newKlientMesto = "";
        this.newKlientUlice = "";
        this.newKlientPSC = "";
        this.newKlientPoznamka = "";
        klient.then(kl => {
            this.props.fakturaceStore.refreshSubjects()
            .then(success => {
                this.props.history.push(`/clients/${kl.id}`);
            });
        });
    }

    @observable private isDrawerOpened: boolean = false;
    @action
    private drawerMenuClick = event => {
        this.isDrawerOpened = !this.isDrawerOpened;
    }

    @action
    private handleCreateNewClient = event => {
        this.isNewKlientDialogOpened = true;
    }

    private handleClientClick = client => evt => {
        this.props.history.push(`/clients/${client.id}`)
    }

    @action
    private handleFilterChange = event => {
        this.filter = event.target.value;
    }

    public render() {
        return (
            <div>
                <Drawer open={this.isDrawerOpened} onClose={this.drawerMenuClick}>
                    <NavigationDrawerItems />
                </Drawer>
                <Grid container spacing={8}>
                    <Grid item xs={12}>
                        <AppBar position="static" >
                            <Toolbar>
                                <IconButton color="inherit" aria-label="Menu" onClick={this.drawerMenuClick}>
                                    <MenuIcon />
                                </IconButton>
                                <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                                    Klienti
                                </Typography>
                                <Tooltip title="Přidat klienta" aria-label="Přidat klienta">
                                    <IconButton color="inherit" aria-label="Přidat klienta" onClick={this.handleCreateNewClient}>
                                        <AddIcon />
                                    </IconButton>
                                </Tooltip>
                            </Toolbar>
                        </AppBar>
                    </Grid>
                    <Grid item xs={12} style={{ margin: 8 }}>
                        <Paper>
                            <Grid container spacing={8}>
                                <Grid item xs={12} style={{paddingLeft: '12px'}}>
                                    <RadioGroup value={this.filter} style={{flexDirection: 'unset'}} onChange={this.handleFilterChange}>
                                        <FormControlLabel value="active" control={<Radio />} label={"Aktivní (" + this.filterActive.length + ")"} />
                                        <FormControlLabel value="all" control={<Radio />} label={"Všichni (" + this.props.klientStore.klients.length + ")"} />
                                        <FormControlLabel value="new" control={<Radio />} label={"S novou objednávkou (" + this.filterNew.length + ")"} />
                                        <FormControlLabel value="sent" control={<Radio />} label={"S nezaplacenou objednávkou (" + this.filterUnpaid.length + ")"} />
                                    </RadioGroup>
                                </Grid>
                                <Grid item xs={12}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Jméno</TableCell>
                                                <TableCell>Příjmení</TableCell>
                                                <TableCell>Telefon</TableCell>
                                                <TableCell>E-mail</TableCell>
                                                <TableCell>Město</TableCell>
                                                <TableCell>Ulice</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                this.klientComputed.map(klient => (
                                                    <TableRow hover key={klient.id} onClick={this.handleClientClick(klient)}>
                                                        <TableCell>{klient.jmeno}</TableCell>
                                                        <TableCell>{klient.prijmeni}</TableCell>
                                                        <TableCell>{klient.telefon}</TableCell>
                                                        <TableCell>{klient.email}</TableCell>
                                                        <TableCell>{klient.mesto}</TableCell>
                                                        <TableCell>{klient.ulice}</TableCell>
                                                    </TableRow>
                                                ))
                                            }
                                        </TableBody>
                                    </Table>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
                <Dialog
                    open={this.isNewKlientDialogOpened}
                    onClose={this.onCloseDialog}
                    aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Klient</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Zadejte údaje nového klienta
                        </DialogContentText>

                        <Grid container spacing={8}>
                            <Grid item xs={6}>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="name"
                                    label="Jméno"
                                    type="string"
                                    value={this.newKlientJmeno}
                                    onChange={this.handleChange('newKlientJmeno')}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    id="lastName"
                                    label="Příjmení"
                                    type="string"
                                    value={this.newKlientPrijmeni}
                                    onChange={this.handleChange('newKlientPrijmeni')}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    id="phone"
                                    label="Telefon"
                                    type="string"
                                    value={this.newKlientTelefon}
                                    onChange={this.handleChange('newKlientTelefon')}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    id="email"
                                    label="Email"
                                    type="string"
                                    value={this.newKlientEmail}
                                    onChange={this.handleChange('newKlientEmail')}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    id="street"
                                    label="Ulice/ČP"
                                    type="string"
                                    value={this.newKlientUlice}
                                    onChange={this.handleChange('newKlientUlice')}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    id="city"
                                    label="Město"
                                    type="string"
                                    value={this.newKlientMesto}
                                    onChange={this.handleChange('newKlientMesto')}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    id="zip"
                                    label="PSČ"
                                    type="string"
                                    value={this.newKlientPSC}
                                    onChange={this.handleChange('newKlientPSC')}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    margin="dense"
                                    id="note"
                                    label="Poznámka"
                                    type="string"
                                    multiline
                                    fullWidth
                                    value={this.newKlientPoznamka}
                                    onChange={this.handleChange('newKlientPoznamka')}
                                />
                            </Grid>
                        </Grid>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.onCloseDialog} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.onSaveNewKlient} color="primary">
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default withRouter(Clients)



// WEBPACK FOOTER //
// ./src/components/Clients.tsx